// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './common/js/font'
import './common/style/common.css'
import 'swiper/dist/css/swiper.css';
// import swiper from 'swiper'

Vue.config.productionTip = false
Vue.prototype.$appName = '悠伊';
Vue.prototype.$company = '广西岩榔网络科技有限公司';
Vue.prototype.$companyShort="岩榔科技";
Vue.prototype.$beian = '桂ICP备2023001315号';
Vue.prototype.$gbeian = '粤公网安备44010602012791号';
Vue.prototype.$email = 'gxyl520360@163.com';
Vue.prototype.$apk = '';

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js